import { render, staticRenderFns } from "./ClassContentList.vue?vue&type=template&id=e1195c4e"
import script from "../../services/student/class-content-list.js?vue&type=script&lang=js&external"
export * from "../../services/student/class-content-list.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/content-list.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports